module.exports = __webpack_public_path__ + "img/sweden-map.30b81722.gif";